import React, { ReactNode } from 'react';

import { Typography, TypographyProps } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { PersonalColorOptions } from 'components/CustomButton';
import { ITheme } from 'styles';

const variant = {
  'big-title': '40px',
  'desk-variation-two': '32px',
  'desk-variation-one': '28px',
  'desk-simple': '24px',
  'desk-small': '22px',
  'mob-simple': '20px',
  'mob-variation-two': '18px',
  'mob-variation-one': '14px',
};

const weight = {
  biggest: 900,
  big: 700,
  semi: 600,
  medium: 500,
  simple: 400,
  light: 300,
};

type TypographyCNProps = TypographyProps & {
  fontType?: 'Roboto' | 'Proxima Nova';
  text?: string;
  color?: PersonalColorOptions;
  children?: ReactNode;
  size?: keyof typeof variant;
  weight?: keyof typeof weight;
  component?: any;
};

/* eslint-disable */
const useStyles = makeStyles<ITheme, TypographyCNProps>(theme => ({
  root: props => {
    const customFont = `${props?.fontType || 'Roboto'}, sans-serif`;
    const defaultColor = theme.palette[props?.color || 'primary'];
    const fontSize = variant[props?.size || 'desk-simple'];
    const fontWeight = weight[props?.weight || 'simple'];

    return {
      fontFamily: customFont,
      fontSize: fontSize,
      fontWeight: fontWeight as number,
      color: props.color ? defaultColor.main : theme.palette.typographyColor,
    };
  },
}));

export function TypographyCN(props: TypographyCNProps) {
  const classes = useStyles(props);
  const { children, text, ...rest } = props;

  return (
    <Typography classes={{ root: classes.root }} {...rest}>
      {children ? children : text}
    </Typography>
  );
}
